import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import isNullOrUndefined from 'scaleflow/utils/isNullOrUndefined';
import { BON_INIT } from './back-of-a-napkin';
import { service } from '@ember/service';

export default class BacklogInitiativesInitiativeReturnsController extends Controller {
  @service store;

  @tracked editMode = false;
  @tracked showReturnConfidenceSlideover = false;
  @tracked showUpsellValueSlideover = false;
  @tracked showFteSlideover = false;
  @tracked showClvSlideover = false;
  @tracked showCustomerValuesSlideover = false;

  @tracked bon = {
    value: undefined,
    notes: '',
    text_delta: {
      ops: [],
    },
    investments: {
      value: 0,
      calculations: [],
    },
    returns: {
      value: 0,
      calculations: [],
    },
  };

  @action
  toggleReturnConfidenceSlideover(flag) {
    if (flag !== undefined && typeof flag === 'boolean')
      this.showReturnConfidenceSlideover = flag;
    else
      this.showReturnConfidenceSlideover = !this.showReturnConfidenceSlideover;
  }

  @action
  toggleClvSlideover(flag) {
    if (flag !== undefined && typeof flag === 'boolean')
      this.showClvSlideover = flag;
    else this.showClvSlideover = !this.showClvSlideover;
  }

  @action
  toggleCustomerValuesSlideover(flag) {
    if (flag !== undefined && typeof flag === 'boolean')
      this.showCustomerValuesSlideover = flag;
    else this.showCustomerValuesSlideover = !this.showCustomerValuesSlideover;
  }

  @action
  toggleFteSlideover(flag) {
    if (flag !== undefined && typeof flag === 'boolean')
      this.showFteSlideover = flag;
    else this.showFteSlideover = !this.showFteSlideover;
  }

  @action
  toggleUpsellValueSlideover(flag) {
    if (flag !== undefined && typeof flag === 'boolean')
      this.showUpsellValueSlideover = flag;
    else this.showUpsellValueSlideover = !this.showUpsellValueSlideover;
  }

  @action
  toggleBonSlideover(flag) {
    if (flag !== undefined && typeof flag === 'boolean')
      this.showBonSlideover = flag;
    else this.showBonSlideover = !this.showBonSlideover;
  }

  @action
  togglePpwSlideover(flag) {
    if (flag !== undefined && typeof flag === 'boolean')
      this.showPpwSlideover = flag;
    else this.showPpwSlideover = !this.showPpwSlideover;
  }

  @action
  updateBonReturns(returns) {
    const bon = this.bon;
    if (bon.returns == undefined) bon.returns = { value: 0, calculations: [] };
    bon.returns.calculations = returns.calculations;
    bon.returns.value = returns.calculations.reduce((acc, curr) => {
      return acc + (curr?.value || 0) * (curr?.confidence_value || 0);
    }, 0);

    const bonValue = this.calculateBonValue(bon);
    bon.value = bonValue;
    this.bon = bon;
  }

  calculateBonValue(bon) {
    if (
      (isNullOrUndefined(bon?.returns) ||
        (bon.returns?.value === 0 &&
          bon.returns?.calculations?.length === 0)) &&
      (isNullOrUndefined(bon?.investments) ||
        (bon.investments?.value === 0 &&
          bon.investments?.calculations?.length === 0))
    )
      return undefined;
    else return (+bon.returns?.value || 0) - (+bon.investments?.value || 0);
  }

  newCustomerTemplateValidator(type, item, index) {
    let hasErrors = false;
    if (item.new_customers === '' || isNaN(item.new_customers)) {
      hasErrors = true;
      document
        .getElementById(`${type}-new-customers-${index}`)
        .classList.add('input--error');
    } else
      document
        .getElementById(`${type}-new-customers-${index}`)
        .classList.remove('input--error');

    return hasErrors;
  }

  newCustomerV2TemplateValidator(type, item, index) {
    let hasErrors = false;
    if (item.new_customers === '' || isNaN(item.new_customers)) {
      hasErrors = true;
      document
        .getElementById(`${type}-new-customers-v2-${index}`)
        .classList.add('input--error');
    } else
      document
        .getElementById(`${type}-new-customers-v2-${index}`)
        .classList.remove('input--error');

    if (!item.bon_clv || isNaN(item.bon_clv)) {
      hasErrors = true;
      document
        .getElementById(`${type}-customer-values-dropdown-${index}`)
        .classList.add('input--error');
    } else
      document
        .getElementById(`${type}-customer-values-dropdown-${index}`)
        .classList.remove('input--error');

    return hasErrors;
  }

  upsellTemplateValidator(type, item, index) {
    let hasErrors = false;
    if (item.customers === '' || isNaN(item.customers)) {
      hasErrors = true;
      document
        .getElementById(`${type}-customers-${index}`)
        .classList.add('input--error');
    } else
      document
        .getElementById(`${type}-customers-${index}`)
        .classList.remove('input--error');

    if (item.upsell_value === '' || isNaN(item.upsell_value)) {
      hasErrors = true;
      document
        .getElementById(`${type}-upsell-value-${index}`)
        .classList.add('input--error');
    } else
      document
        .getElementById(`${type}-upsell-value-${index}`)
        .classList.remove('input--error');

    return hasErrors;
  }

  costFteTemplateValidator(type, item, index) {
    let hasErrors = false;
    if (item.ftes === '' || isNaN(item.ftes)) {
      hasErrors = true;
      document
        .getElementById(`${type}-ftes-${index}`)
        .classList.add('input--error');
    }

    if (!hasErrors) {
      document
        .getElementById(`${type}-ftes-${index}`)
        .classList.remove('input--error');
    }

    return hasErrors;
  }

  @action
  bonHasIncompleteTemplates() {
    const returns = this.bon.returns?.calculations;
    let formsHaveError = [];
    returns?.forEach((item, index) => {
      if (item.type === 'custom')
        formsHaveError.push(
          this.customTemplateValidator('Return', item, index),
        );
      if (item.type === 'new-customers')
        formsHaveError.push(
          this.newCustomerTemplateValidator('Return', item, index),
        );

      if (item.type === 'new-customers-v2')
        formsHaveError.push(
          this.newCustomerV2TemplateValidator('Return', item, index),
        );

      if (item.type === 'upsell')
        formsHaveError.push(
          this.upsellTemplateValidator('Return', item, index),
        );
      if (item.type === 'cost-fte')
        formsHaveError.push(
          this.costFteTemplateValidator('Return', item, index),
        );
    });
    return formsHaveError.includes(true);
  }

  @action
  formatBon() {
    const bon = this.bon;
    if (bon.investments?.calculations) {
      bon.investments?.calculations.forEach((item) => {
        if (item.type === 'custom') return;
        if (item.type === 'investment' || item.type === 'person-weeks-role') {
          const value = +item?.price_person_week * +item?.weeks * +item?.people;
          item.value = isNaN(value) ? null : value;
        }
      });
    }

    if (bon.returns?.calculations) {
      bon.returns?.calculations.forEach((item) => {
        if (item.type === 'custom') return;
        if (item.type === 'cost-fte') {
          const value =
            +item?.ftes * +item?.price_person_week * +item?.horizon * 4;
          item.value = isNaN(value) ? null : value;
        }
        if (item.type === 'new-customers' || item.type === 'new-customers-v2') {
          const value = +item?.new_customers * +item?.bon_clv;
          item.value = isNaN(value) ? null : value;
        }
        if (item.type === 'upsell') {
          const value = +item?.customers * +item.upsell_value;
          item.value = isNaN(value) ? null : value;
        }
      });
    }
    if (
      bon?.text_delta &&
      bon?.text_delta?.ops &&
      bon?.text_delta?.ops?.length === 1 &&
      Object.keys(bon?.text_delta?.ops?.[0])?.length === 0
    ) {
      bon.text_delta = {
        ops: [],
      };
    }
  }

  customTemplateValidator(type, item, index) {
    let hasErrors = false;
    if (item.description === '' || !item.description) {
      hasErrors = true;
      document
        .getElementById(`${type}-custom-description-${index}`)
        .classList.add('input--error');
    } else
      document
        .getElementById(`${type}-custom-description-${index}`)
        .classList.remove('input--error');
    if (item.value === '' || isNaN(+item.value)) {
      hasErrors = true;
      document
        .getElementById(`${type}-custom-value-${index}`)
        .classList.add('input--error');
    } else
      document
        .getElementById(`${type}-custom-value-${index}`)
        .classList.remove('input--error');

    return hasErrors;
  }

  @action
  toggleEditMode(val = undefined) {
    if (val === undefined) this.editMode = !this.editMode;
    else this.editMode = val;
    this.formatBon();
  }

  @action
  async resetBon() {
    if (!this.bon?.id) {
      // New unsaved record — discard it and create a fresh one so
      // `this.bon` remains a store record (with .save()) after cancel.
      if (this.bon && typeof this.bon.unloadRecord === 'function') {
        this.bon.unloadRecord();
      }
      this.bon = this.store.createRecord('bon', {
        initiative: this.model,
        value: BON_INIT.value,
        investments: { value: 0, calculations: [] },
        returns: { value: 0, calculations: [] },
        notes: BON_INIT.notes,
      });
    } else {
      this.bon.rollbackAttributes();
      const bon = await this.store.findRecord('bon', this.bon.id, {
        reload: true,
      });
      this.bon = bon;
    }
    this.toggleEditMode();
  }

  @action
  handleSave(e) {
    e.preventDefault();
    if (this.bonHasIncompleteTemplates()) return;
    this.bon.initiative = this.model;
    this.bon.value = this.calculateBonValue(this.bon);
    this.bon.save().then(() => {
      this.toggleEditMode();
      this.model.reload();
    });
  }
}
